module.exports = __webpack_public_path__ + "img/DHLGlobalMail.png";